<script>
  import { createEventDispatcher } from 'svelte';
  export let value;

  const dispatch = createEventDispatcher();
</script>

<label class="switch">
  <input type="checkbox" bind:checked={value} on:change={e => dispatch('change', e)}>
  <span class="slider round" />
</label>

<style>
  .switch {
    position: relative;
    display: inline-block;
    width: 34px;
    height: 12px;
  }
  
  .switch input { 
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #E0E8F6;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: -3px;
    bottom: -3px;
    background-color: #B6C8F9;
    -webkit-transition: .4s;
    transition: .4s;
  }
  
  input:checked + .slider {
    background-color: #D6DCFF;
  }

  input:checked + .slider::before {
    background-color: #576CED;
  }
  
  input:focus + .slider {
    box-shadow: 0 0 1px #D6DCFF;
  }
  
  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }
  
  .slider.round {
    border-radius: 34px;
  }
  
  .slider.round:before {
    border-radius: 50%;
  }
</style>